//SEC Hero
import HeroBg from '@/images/features/hero/features-hero-bg.png';
import MediaVideoPoster from '@/images/features/media/video-poster.png';

// SEC Point of Sale of the Future
import MarthaGeilman from '@/images/temp/martha-geilman.png';
import CoopLogo from '@/images/common/logos/coop-logo.png';
import Pos from '@/assets/svg/icons/pos.svg';
import Hospitality from '@/assets/svg/icons/hospitality.svg';
import InventoryManagement from '@/assets/svg/icons/inventory-management.svg';
import PricingManagement from '@/assets/svg/icons/pricing-management.svg';
import Mobility from '@/assets/svg/icons/mobility.svg';
import Delivery from '@/assets/svg/icons/delivery.svg';

// SEC Marketing
import MarthaGeilman3 from '@/images/temp/martha-geilman-3.png';
import LavebaLogo from '@/images/common/logos/laveba-logo.png';
import PersonalizedMarketing from '@/assets/svg/icons/personalized-marketing.svg';
import CampaignManagement from '@/assets/svg/icons/campaign-management.svg';
import RealtimeInsights from '@/assets/svg/icons/realtime-insights.svg';
import DynamicPricing from '@/assets/svg/icons/dynamic-pricing.svg';

// SEC Management
import MarthaGeilman2 from '@/images/temp/martha-geilman-2.png';
import SocarLogo from '@/images/common/logos/socar-logo.png';
import Dashboard from '@/assets/svg/icons/dashboard.svg';
import Reporting from '@/assets/svg/icons/reporting.svg';
import CentrilizedManagement from '@/assets/svg/icons/centrilized-management.svg';
import UserGroups from '@/assets/svg/icons/user-groups.svg';
import Api from '@/assets/svg/icons/api.svg';

// SEC runDevice
import CloudPartnerLogo from '@/images/features/cloud/logo-gold-partner.png';
import RunDevice from '@/images/features/run-device/device-desktop.png';

// SEC Cases
import CasesMigrolino from '@/images/temp/migrolino.png';
import CasesCoop from '@/images/temp/coop.png';

const FeaturesData = {
  hero: {
    page_name: 'Features',
    title: 'Designed to grow sales, serve faster, retain &',
    marked_title: 'make customers happy',
    description:
      'Cirrus is a comprehensive feature-rich platform which consolidate and streamline POS workflows',
    media: HeroBg,
  },
  media: {
    video: '',
    poster: MediaVideoPoster,
    slogan_list: ['Integrity.', 'Connectivity.', 'Flexibility.'],
  },
  point_of_sale: {
    title: 'Point of Sale of the Future',
    description:
      'Speed-up checkout & enhance your customers experience with feature-rich POS platform ',
    list: [
      {
        icon: Pos,
        title: 'POS (Point of Sale)',
        text: 'Lorem ipsum dolor sit amet',
      },
      {
        icon: Hospitality,
        title: 'Hospitality',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: InventoryManagement,
        title: 'Inventory Management',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: PricingManagement,
        title: 'Pricing Management',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: Mobility,
        title: 'In-Store Mobility',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: Delivery,
        title: 'Click & Collect / Delivery ',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
    ],
    testimonial: {
      author_photo: MarthaGeilman,
      bloquote:
        '“With Cirrus we can make up to 100 price changes during the day without any hassle. System predicts transaction volume and help to leverage timeframe opportunities to gain the profit”',
      first_name: 'Martha',
      last_name: 'Geilman',
      position: 'Store Manager, COOP',
      company_logo: CoopLogo,
    },
    button: {
      text: 'Request product tour',
      url: '#',
    },
  },
  marketing: {
    title: 'A swiss army knife for your store marketing & promotion',
    description:
      'Enhance customer experience by streamlining your marketing workflows for more sales & less hussle ',
    list: [
      {
        icon: PersonalizedMarketing,
        title: 'Personalized Marketing',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: CampaignManagement,
        title: 'Campaign Management ',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: RealtimeInsights,
        title: 'Realtime Insights',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: DynamicPricing,
        title: 'Dynamic Pricing',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
    ],
    testimonial: {
      author_photo: MarthaGeilman3,
      bloquote:
        '“With Cirrus we can make up to 100 price changes during the day without any hassle. System predicts transaction volume and help to leverage timeframe opportunities to gain the profit”',
      first_name: 'Martha',
      last_name: 'Geilman',
      position: 'Store Manager, Laveba',
      company_logo: LavebaLogo,
    },
    button: {
      text: 'Request product tour',
      url: '#',
    },
  },
  management: {
    title: 'Management',
    description: 'An ultimate efficiency in your daily operations',
    list: [
      {
        icon: Dashboard,
        title: 'Customizable Dashboards',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: Reporting,
        title: 'Reporting',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: UserGroups,
        title: 'User groups & roles',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: CentrilizedManagement,
        title: 'Centrilized management',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: Api,
        title: 'Integrations (API)',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
      {
        icon: Pos,
        title: 'User groups & roles',
        text:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do ',
      },
    ],
    testimonial: {
      author_photo: MarthaGeilman2,
      bloquote:
        '“With Cirrus we can make up to 100 price changes during the day without any hassle. System predicts transaction volume and help to leverage timeframe opportunities to gain the profit”',
      first_name: 'Martha',
      last_name: 'Geilman',
      position: 'Store Manager, Socar',
      company_logo: SocarLogo,
    },
    button: {
      text: 'Request product tour',
      url: '#',
    },
  },
  cloud: {
    title: {
      markered: 'Runs in cloud',
      default: ': a faster and safer way to work',
    },
    advantages_list: [
      {
        title: '99.98%',
        text: 'accessibility rate for MS Azure cloud storage ',
      },
      {
        title: 'up to 4.6x ',
        text:
          'faster data response time comparing traditional server-based setups *',
      },
    ],
    benefits_list: [
      {
        title: 'Own & manage your data safely',
        text:
          'Your data is 100% safely stored in private cluster on Microsoft Azure platform.',
      },
      {
        title: 'Reduce downtimes to zero',
        text: 'Get rid of hardware-dependent issues and synchronization hassle',
      },
      {
        title: 'Scale your operations with a click of a button',
        text:
          'Gradually upscale or downscale your infrastructure without CAPEX needed',
      },
    ],
    partner_logo: CloudPartnerLogo,
    button: {
      text: 'Learn more from our support team',
      url: '#',
    },
  },
  run_device: {
    title: 'Runs equally great on any device and platform',
    description:
      'Unplug your business from hardware and software dependencies by running your POS software wherever you need it. More mobility and user experience for your personnel and management.',
    image: RunDevice,
  },
  cases: {
    title: 'Success inspires for changes. Discover our case studies.',
    list_news: [
      {
        image: CasesMigrolino,
        title: 'Migrolino',
        description: 'An ultimate efficiency in your daily operations',
        url: '#',
      },
      {
        image: CasesCoop,
        title: 'Coop',
        description: 'An ultimate efficiency in your daily operations',
        url: '#',
      },
    ],
    logos: [],
  },
};

export default FeaturesData;
